"use client";

import { Box, HStack, Image, Marquee, Text } from "@chakra-ui/react";

function splitIntoColumns(images = []) {
  const out = [[], [], []];
  images.forEach((src, idx) => {
    out[idx % 3].push(src);
  });
  return out;
}

const ImageGallery = ({ images = [] }) => {
  if (!Array.isArray(images) || images.length === 0) {
    return (
      <Box
        height="280px"
        borderWidth="1px"
        borderColor="gray.200"
        rounded="xl"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Text color="fg.muted">Aun no hay fotos disponibles.</Text>
      </Box>
    );
  }

  const [imagesColumn1, imagesColumn2, imagesColumn3] = splitIntoColumns(images);

  return (
    <Box height="500px" overflow="hidden" perspective="500px">
      <HStack
        gap="4"
        height="700px"
        transform="rotateX(20deg)"
        transformOrigin="center top"
      >
        <Marquee.Root side="top" flex="1" autoFill>
          <Marquee.Viewport>
            <Marquee.Content>
              <MarqueeItems images={imagesColumn1.length ? imagesColumn1 : images} />
            </Marquee.Content>
          </Marquee.Viewport>
        </Marquee.Root>

        <Marquee.Root side="bottom" flex="1" autoFill>
          <Marquee.Viewport>
            <Marquee.Content>
              <MarqueeItems images={imagesColumn2.length ? imagesColumn2 : images} />
            </Marquee.Content>
          </Marquee.Viewport>
        </Marquee.Root>

        <Marquee.Root side="top" flex="1" autoFill>
          <Marquee.Viewport>
            <Marquee.Content>
              <MarqueeItems images={imagesColumn3.length ? imagesColumn3 : images} />
            </Marquee.Content>
          </Marquee.Viewport>
        </Marquee.Root>
      </HStack>
    </Box>
  );
};

const MarqueeItems = ({ images }) => {
  return (
    <>
      {images.map((src, i) => (
        <Marquee.Item key={i} py="2">
          <Image
            src={src}
            alt={`Gallery image ${i + 1}`}
            width="full"
            height="200px"
            objectFit="cover"
            rounded="lg"
            shadow="md"
          />
        </Marquee.Item>
      ))}
    </>
  );
};

export default ImageGallery;
